"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");require("core-js/modules/es6.regexp.to-string");require("core-js/modules/es6.regexp.constructor");require("core-js/modules/es6.regexp.replace");var _vue = _interopRequireDefault(require("vue"));
var _axios = _interopRequireDefault(require("axios"));
var _request = _interopRequireDefault(require("@/utils/request"));
var _store = _interopRequireDefault(require("@/store"));

/**
                                                          * 数据取反
                                                          * 可用于boolean的取反显示/隐藏列
                                                          */
_vue.default.prototype.showHide = function (data) {
  data = !data;
};

/**
    *  设置对齐方式：居中
    *  用于table表格得表头和内容居中
    */
_vue.default.prototype.isCenter = function () {
  return 'text-align: center';
};

_vue.default.prototype.getData = function (url, data, callback) {// get
  var self = this;
  var loading = this.$loading({
    background: 'rgba(0,0,0,0)' });

  (0, _request.default)({
    url: url,
    method: 'get',
    params: data }).
  then(function (response) {
    setTimeout(function () {
      loading.close();
    }, 100);
    // console.log('response=====>',response)
    if (response.errCode === '0') {
      return callback(response.data);
    } else if (response.errCode === 'E1001') {
      _store.default.dispatch('user/resetToken').then(function () {
        location.reload();
      });
    } else {
      self.$alert(response.errMsg, '错误提示', {
        confirmButtonText: '确定1' });

    }
  }).catch(function (error) {
    setTimeout(function () {
      loading.close();
    }, 100);
    console.log('get-error=====>', error);
  });
  // axios.get(url, { params: data })
  //   .then(function(response) {
  //     setTimeout(() => {
  //       loading.close()
  //     }, 100)
  //     if (response.data.errCode === '0') {
  //       return callback(response.data.data)
  //     } else if (response.data.errCode === 'E1001') {
  //       self.$router.push({ path: '/login' })
  //     } else {
  //       self.$alert(response.data.errMsg, '错误提示', {
  //         confirmButtonText: '确定'
  //       })
  //     }
  //   })
  //   .catch(function(error) {
  //     setTimeout(() => {
  //       loading.close()
  //     }, 100)
  //     console.log(error)
  //   })
};

_vue.default.prototype.getSelectData = function (url, data, callback) {// 没有加载动画的get
  (0, _request.default)({
    url: url,
    method: 'get',
    params: data }).
  then(function (response) {
    if (response.errCode === '0') {
      return callback(response.data);
    } else {
      return [];
    }
  }).catch(function (error) {
    console.log('get-select-error=====>', error);
    return [];
  });
  // axios.get(url, { params: data })
  //   .then(function(response) {
  //     if (response.data.errCode === '0') {
  //       return callback(response.data.data)
  //     } else {
  //       return []
  //     }
  //   })
  //   .catch(function(error) {
  //     console.log(error)
  //     return []
  //   })
};

_vue.default.prototype.delData = function (url, data, callback) {// 删除
  var self = this;
  var loading = this.$loading({
    background: 'rgba(0,0,0,0)' });

  (0, _request.default)({
    url: url,
    method: 'delete',
    params: data }).
  then(function (response) {
    setTimeout(function () {
      loading.close();
    }, 100);
    if (response.errCode === '0') {
      return callback(response.data);
    } else if (response.errCode === 'E1001') {
      _store.default.dispatch('user/resetToken').then(function () {
        location.reload();
      });
    } else {
      self.$alert(response.errMsg, '错误提示', {
        confirmButtonText: '确定' });

    }
  }).catch(function (error) {
    setTimeout(function () {
      loading.close();
    }, 100);
    console.log('delete-error======>', error);
  });
  // axios.delete(url, { params: data })
  //   .then(function(response) {
  //     setTimeout(() => {
  //       loading.close()
  //     }, 100)
  //     if (response.data.errCode === '0') {
  //       return callback(response.data.data)
  //     } else if (response.data.errCode === 'E1001') {
  //       self.$router.push({ path: '/login' })
  //     } else {
  //       self.$alert(response.data.errMsg, '错误提示', {
  //         confirmButtonText: '确定'
  //       })
  //     }
  //   })
  //   .catch(function(error) {
  //     setTimeout(() => {
  //       loading.close()
  //     }, 100)
  //     console.log(error)
  //   })
};

_vue.default.prototype.putData = function (url, data, callback) {var _this = this; // 删除
  console.log('url======>', url);
  console.log('data======>', data);
  console.log('callback======>', callback);
  var self = this;
  var loading = this.$loading({
    background: 'rgba(0,0,0,0)' });

  (0, _request.default)({
    url: url,
    method: 'put',
    data: data }).
  then(function (response) {
    console.log('put-response=====>', JSON.stringify(response));
    setTimeout(function () {
      loading.close();
    }, 100);
    if (response.errCode === '0') {
      return callback(response.data);
    } else if (response.errCode === 'E1001') {
      _store.default.dispatch('user/resetToken').then(function () {
        location.reload();
      });
    } else {
      _this.$alert(response.errMsg, '错误提示', {
        confirmButtonText: '确定' });

    }
  }).catch(function (error) {
    setTimeout(function () {
      loading.close();
    }, 100);
    console.log('put-error======>', error);
  });
  // axios.put(url, data)
  //   .then(function(response) {
  //     setTimeout(() => {
  //       loading.close()
  //     }, 100)
  //     if (response.data.errCode === '0') {
  //       return callback(response.data.data)
  //     } else if (response.data.errCode === 'E1001') {
  //       self.$router.push({ path: '/login' })
  //     } else {
  //       self.$alert(response.data.errMsg, '错误提示', {
  //         confirmButtonText: '确定'
  //       })
  //     }
  //   })
  //   .catch(function(error) {
  //     setTimeout(() => {
  //       loading.close()
  //     }, 100)
  //     console.log(error)
  //   })
};

_vue.default.prototype.postData = function (url, data, callback) {var _this2 = this; // post
  var self = this;
  var loading = this.$loading({
    background: 'rgba(0,0,0,0)' });

  (0, _request.default)({
    url: url,
    method: 'post',
    data: data }).
  then(function (response) {
    setTimeout(function () {
      loading.close();
    }, 100);
    if (response.errCode === '0') {
      return callback(response.data);
    } else if (response.errCode === 'E1001') {
      _store.default.dispatch('user/resetToken').then(function () {
        location.reload();
      });
    } else {
      _this2.$alert(response.errMsg, '错误提示', {
        confirmButtonText: '确定' });

    }
  }).catch(function (error) {
    setTimeout(function () {
      loading.close();
    }, 100);
    console.log('post-error======>', error);
  });
  // axios.post(url, data)
  //   .then(function(response) {
  //     setTimeout(() => {
  //       loading.close()
  //     }, 100)
  //     if (response.data.errCode === '0') {
  //       return callback(response.data.data)
  //     } else if (response.data.errCode === 'E1001') {
  //       self.$alert(response.data.errMsg, '错误提示', {
  //         confirmButtonText: '确定'
  //       })
  //       self.$router.push({ path: '/login' })
  //     } else {
  //       self.$alert(response.data.errMsg, '错误提示', {
  //         confirmButtonText: '确定'
  //       })
  //     }
  //   })
  //   .catch(function(error) {
  //     setTimeout(() => {
  //       loading.close()
  //     }, 100)
  //     console.log(error)
  //   })
};

var herder = {
  headers: {
    'Content-Type': 'multipart/form-data' } };



_vue.default.prototype.postFormData = function (url, data, callback) {var _this3 = this;
  // console.log('postFormData======>',url)
  var self = this;
  var loading = this.$loading({
    background: 'rgba(0,0,0,0)' });

  (0, _request.default)({
    url: url,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' },
    data: data }).
  then(function (response) {
    setTimeout(function () {
      loading.close();
    }, 100);
    if (response.errCode === '0') {
      return callback(response.data);
    } else if (response.errCode === 'E1001') {
      _store.default.dispatch('user/resetToken').then(function () {
        location.reload();
      });
    } else {
      _this3.$alert(response.errMsg, '错误提示', {
        confirmButtonText: '确定' });

    }
  }).catch(function (error) {
    setTimeout(function () {
      loading.close();
    }, 100);
    console.log('postformdata-error=====>', error);
  });
  // axios.post(url, data, herder)
  //   .then(function(response) {
  //     setTimeout(() => {
  //       loading.close()
  //     }, 100)

  //     if (response.data.errCode === '0') {
  //       return callback(response.data.data)
  //     } else if (response.data.errCode === 'E1001') {
  //       self.$alert(response.data.errMsg, '错误提示', {
  //         confirmButtonText: '确定'
  //       })
  //       self.$router.push({ path: '/login' })
  //     } else {
  //       self.$alert(response.data.errMsg, '错误提示', {
  //         confirmButtonText: '确定'
  //       })
  //     }
  //   })
  //   .catch(function(error) {
  //     setTimeout(() => {
  //       loading.close()
  //     }, 100)
  //     console.log(error)
  //   })
};

// Vue.prototype.ajaxData = function(url, data, callback) { // post
//   const self = this
//   const loading = this.$loading({
//     background: 'rgba(0,0,0,0)'
//   })
//   $.ajax({
//     type: 'POST',
//     url: url,
//     data: qs.stringify(data),
//     success: function(response) {
//       setTimeout(() => {
//         loading.close()
//       }, 100)
//       if (response.errCode === '0') {
//         return callback(response.data)
//       } else if (response.errCode === 'E1001') {
//         self.$router.push({ path: '/login' })
//       } else {
//         self.$alert(response.errMsg, '错误提示', {
//           confirmButtonText: '确定'
//         })
//       }
//     },
//     error: function(error) {
//       setTimeout(() => {
//         loading.close()
//       }, 100)
//       console.log(error)
//     }
//   })
// }

_vue.default.filter('dateFilter', function (value) {// 日期格式化
  var fmt = 'yyyy-MM-dd hh:mm:ss';
  if (!value) {
    return '';
  }
  var date = new Date(value);
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds() };

  for (var k in o) {
    if (new RegExp("(".concat(k, ")")).test(fmt)) {
      var str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length));
    }
  }
  return fmt;
});

_vue.default.filter('isAbledFilter', function (value) {// 是否禁用
  switch (parseInt(value)) {
    case 0:
      return '否';
    case 1:
      return '是';
    default:
      return value;}

});

_vue.default.filter('isAuditFilter', function (value) {// 是否审核
  switch (value.toString()) {
    case 'false':
      return '未审核';
    case 'true':
      return '审核';
    default:
      return value;}

});

_vue.default.filter('isAudit2Filter', function (value) {// 是否审核
  switch (parseInt(value)) {
    case 0:
      return '未审核';
    case 1:
      return '审核';
    default:
      return value;}

});

_vue.default.filter('isPublishFilter', function (value) {// 是否审核
  switch (parseInt(value)) {
    case 0:
      return '未发布';
    case 1:
      return '发布';
    default:
      return value;}

});

_vue.default.filter('enableFilter', function (value) {// 是否禁用
  switch (parseInt(value)) {
    case 0:
      return '启用';
    case 1:
      return '禁用';
    default:
      return value;}

});

_vue.default.filter('merchantFilter', function (value) {// 是否禁用
  switch (parseInt(value)) {
    case 0:
      return '一级商户';
    case 1:
      return '二级商户';
    default:
      return value;}

});

_vue.default.filter('isEnabledFilter', function (value) {// 是否可操作
  switch (parseInt(value)) {
    case 0:
      return '是';
    case 1:
      return '否';
    default:
      return value;}

});

_vue.default.filter('payFilter', function (value) {// 支付渠道
  switch (parseInt(value)) {
    case 0:
      return '微信';
    case 1:
      return '支付宝';
    case 2:
      return '光大银行';
    case 3:
      return '免费';
    case 4:
      return '招行';
    case 5:
      return '翼支付';
    default:
      return value;}

});

_vue.default.filter('accountTypeFilter', function (value) {// 支付渠道
  switch (parseInt(value)) {
    case 0:
      return '个人';
    case 1:
      return '企业';
    default:
      return value;}

});

_vue.default.filter('dataStatusFilter', function (value) {// 支付渠道
  switch (parseInt(value)) {
    case 0:
      return '有效';
    case 1:
      return '无效';
    default:
      return value;}

});

_vue.default.filter('wdStatusFilter', function (value) {// 提现状态
  switch (parseInt(value)) {
    case 0:
      return '提现处理中';
    case 3:
      return '提现成功';
    case 4:
      return '提现失败';
    default:
      return value;}

});

_vue.default.filter('refundTypeFilter', function (value) {// 退款状态
  switch (parseInt(value)) {
    case 0:
      return '成功';
    case 1:
      return '失败';
    case 2:
      return '待处理';
    default:
      return value;}

});

_vue.default.filter('feePayerFilter', function (value) {// 手续费承担方
  switch (parseInt(value)) {
    case 0:
      return '商户平台';
    case 1:
      return '会员';
    default:
      return value;}

});

_vue.default.filter('orderTypeFilter', function (value) {// 订单状态
  switch (parseInt(value)) {
    case 0:
      return '支付成功';
    case 1:
      return '自动退款';
    case 2:
      return '手动退款';
    case 3:
      return '未支付';
    default:
      return value;}

});

_vue.default.filter('busTypeFilter', function (value) {// 经营类型
  switch (value) {
    case 1:
      return '联营';
    case 2:
      return '买断';
    case 3:
      return '直营';
    default:
      return value;}

});

// Date.prototype.Format = function(fmt) { // author: meizz
//   var o = {
//     'M+': this.getMonth() + 1, // 月份
//     'd+': this.getDate(), // 日
//     'h+': this.getHours(), // 小时
//     'm+': this.getMinutes(), // 分
//     's+': this.getSeconds(), // 秒
//     'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
//     'S': this.getMilliseconds() // 毫秒
//   }
//   if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
//   for (var k in o) { if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
//   return fmt
// }

_vue.default.prototype.formatDate = function (value) {
  var fmt = 'yyyy-MM-dd hh:mm:ss';
  if (!value) {
    return '';
  }
  var date = new Date(value);
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds() };

  for (var k in o) {
    if (new RegExp("(".concat(k, ")")).test(fmt)) {
      var str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length));
    }
  }
  return fmt;
};